

import { Steps , Modal , Alert, Button,Space, Skeleton, Card,  Typography ,Tooltip} from "antd"

import { CopyOutlined, CustomerServiceOutlined } from "@ant-design/icons";
const { Text } = Typography;
import FileUploadHybrid from "./atoms/FileUpload"
import { useState } from "react"
import apiAction from "../ajax/service"
import {verifyBulkAction} from '../interfaces/bulkActionInterface'
import { useEffect } from "react";
import { useDebugValue } from "react";
const UploadAction = ({open,closeModal}) =>{
    const [currentStep,setCurrentStep]=useState(0)
    const [bulkActionStatus , setBulkActionStatus] = useState({})
    const items = [

        {
            title: 'Upload The Excel Sheet',
            content:'hii'

        },
        {
            title: 'Parsing to Detect Errors Priorly',
            content:'hii'


        }
    ]
useEffect(() => {
  // guard for missing keys using optional chaining
  if (bulkActionStatus?.uploaded) {
    setCurrentStep(1);
    return;
  }

  if (bulkActionStatus?.actionStatus) {
    setCurrentStep(0);
  }
}, [bulkActionStatus]);

   useEffect(() => {
  if (!open) return;

  async function loadStatus() {
    const res = await verifyBulkAction();
    setBulkActionStatus(res);
  }

  loadStatus();
}, [open]);

    return (
        <Modal open={open} onCancel={()=>closeModal()} cancelText={"Back"} okText={"Next"} width={'80%'} title={<><div>Bulk Upload Your Data</div><span>
          <Button className="float-right bg-slate-100 mb-1" onClick={async()=>await apiAction("raw",{url:'/api/template/sample.xlsx',method:'GET'},"download")}  type="link" >Download Sample Sheet</Button></span></>}>
            {bulkActionStatus.actionStatus == true && <Alert type="info" showIcon message={"Your previous file upload seems to be successful , Please verify the uploads. "} />}
            <Steps current={currentStep} titlePlacement="horizontal" items={items} ellipsis />
            {currentStep == 0 && <div className="mt-2"><FileUploadHybrid

                onUpload={async(selectedFile)=>{await apiAction('bulkaction',{file:selectedFile,action:'bulkAction',bulkAction:'rentalUpload'},'bulkAction');setBulkActionStatus(await verifyBulkAction())}}
            />

            </div> }


{
  currentStep === 1 && (
    <div style={{ padding: 12 }}>
      <Space direction="vertical" style={{ width: "100%" }} size="middle">
        {/* Processing: skeleton + message */}
        {!bulkActionStatus.verified && (
          <Card size="small" style={{ borderRadius: 8 }}>
            <Space align="center" style={{ width: "100%", justifyContent: "space-between" }}>
              <div style={{ display: "flex", gap: 12, alignItems: "center", flex: 1 }}>
                <Skeleton active title={false} paragraph={{ rows: 2, width: ["60%", "40%"] }} />
                <div style={{ minWidth: 220 }}>
                  <Text strong>File is being processed</Text>
                  <div style={{ marginTop: 6, color: "var(--ant-gray-6)" }}>
                    Please wait while we verify your file. This usually takes a few seconds.
                  </div>
                </div>
              </div>

              {/* small inline spinner-like skeleton to indicate activity */}
              <div style={{ marginLeft: 12 }}>
                <Skeleton.Avatar active size="large" shape="circle" />
              </div>
            </Space>
          </Card>
        )}

        {/* Verified with errors */}
        {bulkActionStatus.verified && bulkActionStatus.error && (
            <>
            <Alert type="info" message="Error might be detected in-between the process , Please verify the upload and retry with a fresh upload later." />
          <Alert
  type="error"
  message="Something went wrong"
  description={
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>

      {/* Copy Error Button */}
      <Tooltip title="Copy error details">
        <Button
          size="small"
          icon={<CopyOutlined />}
          onClick={() => {
            navigator.clipboard.writeText(bulkActionStatus.error || "");
          }}
        >
          Copy Details
        </Button>
      </Tooltip>

      {/* Support Guidance */}
      <span style={{ fontSize: 12, color: "#555" }}>
        If the issue persists send this error by contacting support with the floating icon below
      </span>

      <CustomerServiceOutlined style={{ color: "#1677ff" }} />
    </div>
  }
  showIcon
/>
          </>
        )}

        {/* Verified and OK */}
        {bulkActionStatus.verified && !bulkActionStatus.error && (
          <Alert
            type="success"
            message="File verified"
            description="No errors were found. You can proceed with the next step."
            showIcon
          />
        )}

        {/* Controls */}
        <div style={{ display: "flex", gap: 8, justifyContent: "flex-start" }}>
          <Button
            type="primary"
            onClick={async() => setBulkActionStatus(await verifyBulkAction())}
             // disabled while processing
          >
            Refresh Status
          </Button>

          <Button
            onClick={() => {
                setCurrentStep(0)
              /* optional: open logs or download errors if available */
            }}
          >
            Upload New
          </Button>
        </div>
      </Space>
    </div>
  )
}


        </Modal>
    )

}

export default UploadAction
